import React from "react";
import classes from "./CheckDetails.module.css";
import CommonUtil from "../../../common";
import constants from "../../../../../globalization";
import MenuUtils from "../../../../../util/menu-utils";
import printIcon from "../../../../../assets/images/Fireboard/print.png";
import infoIcon from "../../../../../assets/images/Fireboard/infoIcon.png";
import editIcon from '../../../../../assets/images/Fireboard/menu_buttons/black-edit.png';
import classNames from "classnames";
import paidIcon from "../../../../../assets/images/Fireboard/paid.png";
import printSuccessIcon from '../../../../../assets/images/Fireboard/print_success.png';
import cookingOrange from '../../../../../assets/images/Fireboard/cooking-orange.png';
import cookingYellow from '../../../../../assets/images/Fireboard/cooking-yellow.png';
import cookingGreen from '../../../../../assets/images/Fireboard/cooking-green.png';
import Discount from "./Discount";
import FireboardUtils from "../../../../../util/fireboard-util";

const CheckItem = (props) => {
  const {
    item = {},
    qrFlow,
    onPrintPress = () => { },
    isPending,
    currency = '$',
  } = props;

  const renderModifiers = (mod, index) => {
    if (mod) {
      const modText =
        mod.quantity > 1
          ? `- ${mod.quantity} x ${mod.modifierName}`
          : `- ${mod.modifierName}`;
      const modString = `${modText} ${mod.price > 0 ? `(${currency} ${mod.price.toFixed(2)})` : ""
        }`;
      const note = mod.quantity > 1 ? `\t\t\t\t\t\t  ${mod.comment}` : `  \t\t\t  ${mod.comment}`;
      const modStyle = { paddingLeft: `${index * 1.5}vw`, width: `${100 - index * 1.5}%` };
      return (
        <>
          <span
            className={classes.checkCellView}
            style={modStyle}
          >
            {modString}
          </span>
          {mod.comment ? (
            <span
              style={modStyle}
              className={classNames(
                `${classes.checkCellView}`,
                `${classes.modNote}`
              )}
            >
              {note}
            </span>
          ) : null}
        </>
      );
    }
    return <span />;
  };

  const renderModifiersRecursively = (im) =>
    MenuUtils.renderModifiersRecursively(
      im,
      0,
      (i, index) => renderModifiers(i, index),
      (i) => { },
      true
    );

  const comment =
    item.quantity > 1 ? `\t\t\t  ${item.comment}` : `  ${item.comment}`;

  const kdsStatusIcon = item?.kdsStatus === 2
    ? cookingYellow
    : item?.kdsStatus === 5
      ? cookingOrange
      : item?.kdsStatus === 8
        ? cookingGreen
        : null;

  return (
    <div className={item.pending ? classNames(
      `${classes.itemContainer}`,
      `${classes.pendingBg}`,
    ) : classes.itemContainer}>
      <div className={classes.rowSpaceBetween}>
        <div className={classes.nameAndPrice}>
          <span
            className={
              item.printed
                ? classNames(
                  `${classes.checkCellView}`,
                  `${classes.name}`,
                  `${classes.printed}`
                )
                : classNames(`${classes.checkCellView}`, `${classes.name}`)
            }
          >
            {`${item.quantity > 1 ? `${item.quantity} x ` : ""}${item.menuItemName
              }`}
          </span>
          <div className={classes.paidBtnWrapper}>
            {item?.paid ? <img src={paidIcon} alt="paid" className={classes.paidImg} /> : null}
          </div>
          {kdsStatusIcon && (
            <div className={classes.kdsStatusWrapper}>
              <img src={kdsStatusIcon} alt="kds" className={classes.ksdIcon} />
              <span className={classes.kdsDateTxt}>{FireboardUtils.getTimeInHrsMins(item?.plannedStartDate)}</span>
            </div>
          )}
          <span
            className={classNames(
              `${classes.checkCellView}`,
              `${classes.price}`
            )}
          >
            {`${currency}${item && item.price && item.price.toFixed(2)}`}
          </span>
          <div className={classes.qrFlow}>
            {qrFlow || isPending ? null : (
              <button
                onClick={() => onPrintPress("item", item)}
                className={classes.itemPrintBtn}
              >
                <img
                  src={item?.printed ? printSuccessIcon : printIcon}
                  alt="print"
                  className={classes.printIconSize}
                />
              </button>
            )}
          </div>
        </div>
        {item.comment ? (
          <span
            className={classNames(
              `${classes.checkCellView}`,
              `${classes.note}`
            )}
          >
            {comment}
          </span>
        ) : null}
        {item.modifiers ? renderModifiersRecursively(item) : null}
      </div>
    </div>
  );
};

const CheckItems = (props) => {
  const {
    items = [],
    selectedItem = {},
    showMemberDetailPopup = () => { },
    posItemKeys = [],
    onPrintPress,
    isPending,
    relatedNotifications,
    acknowledgeIdCheck,
    // showApprovalReasonsPopup,
    currency = '$',
    onClickSms,
    openCaptureSeatNamePopup,
    enableAgeRestrictedOrderingForSeat,
    onUpdateAgeRestrictedItemsForSeat,
  } = props || {};

  const isPOSOrder =
    CommonUtil.getOrderTypeFromSourceType(selectedItem.sourceType) ===
    constants.orderType_POS;

  const invokeApproval = (notification, approval) => {
    const notificationTypeId = notification.notificationTypeId;
    if (notificationTypeId === 14) {
      acknowledgeIdCheck(approval, notification);
    } else if (notificationTypeId === 15) {
      // showApprovalReasonsPopup(approval, notification);
    }
  };

  const sortCheckItemFunc = (a, b) => {
    if (a?.checkItemId == b?.checkItemId) return 0;
    return (a?.checkItemId > b?.checkItemId) ? 1 : -1;
  };

  const getSortedItems = (items) => {
    if (Array.isArray(items))
      return items.sort(sortCheckItemFunc);
    return items;
  };

  const renderPOSCheck = (item) => {
    const itemWithMemberId =
      items && item && items[item] && Array.isArray(items[item])
        ? items[item].find((item) => !!item.section.memberId)
        : {};

    const memberId = itemWithMemberId
      ? itemWithMemberId?.section?.memberId
      : null;

    const seatItems = Array.isArray(items[item]) ? items[item] : [];
    const section = seatItems.length > 0 ? seatItems[0].section : {};
    const disableAgeRestricted = section?.disableAgeRestricted || false;

    const seatId = isPending
      ? Array.isArray(items[item]) &&
      items[item][0] &&
      items[item][0].seatIds &&
      items[item][0].seatIds[0]
      : Array.isArray(items[item]) &&
      items[item][0] &&
      items[item][0].seats &&
      items[item][0].seats.length > 0 &&
      items[item][0].seats[0].seatId;

    const notification = relatedNotifications.filter(n => n.seatId === seatId);

    return (
      <div className={classes.checkItem}>
        {item ? (
          <div className={notification && notification.length > 0 ? [classes.itemSelected, classes.highlightSeat] : classes.itemSelected}>
            <span
              className={classes.selectedItemText}
              style={{
                color: item === constants.discountHeader ? "#AD0028" : "black",
              }}
            >
              {item}
            </span>
            {!!memberId && (
              <div className={classes.infoIconWrapper}>
                <button className={classes.infoBtn} onClick={() => !!memberId && showMemberDetailPopup(memberId)}>
                  <img src={infoIcon} className={classes.infoIconStyle} alt="info" />
                </button>
                <button className={classes.infoBtn} onClick={() => openCaptureSeatNamePopup && openCaptureSeatNamePopup(seatId)}>
                  <img src={editIcon} className={classes.infoIconStyle} alt="rename-seat" />
                </button>
                <div className={classes.smsBtn} onClick={() => onClickSms && onClickSms(seatId)}>SMS</div>
              </div>
            )}
            {enableAgeRestrictedOrderingForSeat && (
              <div className={classes.smsBtn} onClick={() => onUpdateAgeRestrictedItemsForSeat && onUpdateAgeRestrictedItemsForSeat(seatId, disableAgeRestricted)}>
                {disableAgeRestricted ? constants.enableRestricted : constants.disableRestricted}
              </div>
            )}
          </div>
        ) : null}
        {Array.isArray(items[item]) && getSortedItems(items[item]).map((itemObj) => renderCheckItems(itemObj))}

        {notification && notification.length > 0
          ? notification.map(eachNotification =>
            eachNotification.notificationTypeId === 14 ? (
              <div
                className={classes.tableData}
              >
                <span className={classes.approvalLabel}>
                  {eachNotification.notificationTypeId === 14 ? 'ID CHECK' : 'OVER SERVE'}
                </span>
                <div
                  onClick={() => invokeApproval(eachNotification, false)}
                  className={classes.notBtn}
                >
                  <span className={classes.notificationBtnText}>
                    {constants.notification_reject}
                  </span>
                </div>
                <div
                  onClick={() => invokeApproval(eachNotification, true)}
                  className={classes.notBtn}
                >
                  <span className={classes.goAndDismissText}>
                    {constants.notification_approve}
                  </span>
                </div>
              </div>
            ) : null,
          )
          : null}
      </div>
    );
  };

  const renderCheckItems = (item, isPending) => {
    return (
      <CheckItem
        key={`checkItem-${item.id}`}
        item={item}
        selectedItem={selectedItem}
        onPrintPress={onPrintPress}
        currency={currency}
      />
    );
  };

  const checkItemsArray = isPOSOrder ? posItemKeys : getSortedItems(items);

  const renderDiscountAndServiceCharge = () => {
    const { selectedCheckDetails } = selectedItem || {};
    const { discounts, serviceCharges } = selectedCheckDetails || {};
    const isDiscountNotEmpty = Array.isArray(discounts) && discounts.length > 0;
    const isServiceChgNotEmpty = Array.isArray(serviceCharges) && serviceCharges.length > 0;
    const showDiscountAndServiceChg = isDiscountNotEmpty || isServiceChgNotEmpty;
    if (!showDiscountAndServiceChg) return;
    return (
      <React.Fragment>
        <div className={classes.discountHeader}>{constants.discountAndServiceCharges}</div>
        {isDiscountNotEmpty && (
          discounts.map(discount =>
            <div key={`discount-id-${discount.id}`}>
              <Discount data={{ name: discount.discountName, price: discount.value }} currency={currency} />
            </div>
          )
        )}
        {isServiceChgNotEmpty && (
          serviceCharges.map(sCharge =>
            <div key={`service-id-${sCharge.id}`}>
              <Discount data={{ name: sCharge.serviceChargeName, price: sCharge.price }} currency={currency} />
            </div>
          )
        )}
      </React.Fragment >
    );
  };

  return (
    <div className={classNames(`${classes.checkItemsContainer}`)}>
      {Array.isArray(checkItemsArray) && checkItemsArray.length
        ? checkItemsArray.map((item, itemIndex) => {
          if (isPOSOrder) {
            return <div key={`posItem-${itemIndex}`}>{renderPOSCheck(item)}</div>;
          }
          return <div key={`menuItem-${itemIndex}`}>{renderCheckItems(item)}</div>;
        })
        : null}
      {renderDiscountAndServiceCharge()}
    </div>
  );
};

export default CheckItems;
